import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { TransactionsService } from '../../services/transactions.service'
import { MatTableDataSource } from '@angular/material/table';
import { COGS, DateRange, OperatingExpenses, Transaction, TransactionType } from '@contracts/interfaces/transaction.interfaces';
import { ProofViewerDialogService } from '../../dialogs/transaction-dialog/transaction.service.dialog';
import { ACCOUNT } from '../../accounts';
import { ActivatedRoute } from '@angular/router';
import { PDFService } from '../../services/pdf.service';
import { human } from '../../tools/human-currency';
import { TransactionPreset } from '@contracts/interfaces/transaction-preset.interface';
import { AccountService } from 'src/app/services/account.service';
import { BankService } from 'src/app/services/bank.service';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { TransactionPresetsService } from 'src/app/services/transaction-presets.service';
import { MatDialog } from '@angular/material/dialog';
import { TransactionPresetDialogComponent } from 'src/app/dialogs/transaction-preset-dialog/transaction-preset.dialog';
import { BasPeriodSummary, FinancialYearAttachment, FinancialYearSummary } from '@contracts/interfaces/financial-year-summary.interface';
import { FinancialYearSummaryService } from 'src/app/services/financial-year-summary.service';
import { AppSettingsService } from 'src/app/services/app-settings.service';

enum DateMode {
  Weekly,
  Monthly,
  Quaterly,
  Yearly,
  AllTime,
  Custom
}

type BasPeriodMode = 'monthly' | 'quarterly';

@Component({
  selector: 'ap-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.scss', './table.scss']
})
export class AccountingComponent implements OnInit {
  private readonly searchStorageKey = 'booksSearchQuery';
  private readonly sortStorageKey = 'booksSortOption';
  columnsToDisplay = [
    'status',
    'date',
    'description',
    'category',
    'amount',
    'vat',
  ];


  basDateRanges = [
    { label: "April 2023", from: '2023-04-01T00:00:00+10:00', to: '2023-04-30T23:23:59+10:00' },
    { label: "May 2023", from: '2023-05-01T00:00:00+10:00', to: '2023-05-31T23:23:59+10:00' },
    { label: "June 2023", from: '2023-06-01T00:00:00+10:00', to: '2023-06-30T23:23:59+10:00' },
    { label: "2022-2023 Company", from: '2023-04-01T00:00:00+10:00', to: '2023-06-30T23:23:59+10:00' },
    { label: "July 2023", from: '2023-07-01T00:00:00+10:00', to: '2023-07-31T23:23:59+10:00' },
    { label: "August 2023", from: '2023-08-01T00:00:00+10:00', to: '2023-08-31T23:23:59+10:00' },
    { label: "September 2023", from: '2023-09-01T00:00:00+10:00', to: '2023-09-30T23:23:59+10:00' },
    { label: "October 2023", from: '2023-10-01T00:00:00+10:00', to: '2023-10-31T23:23:59+10:00' },
    { label: "November 2023", from: '2023-11-01T00:00:00+10:00', to: '2023-11-30T23:23:59+10:00' },
    { label: "December 2023", from: '2023-12-01T00:00:00+10:00', to: '2023-12-31T23:23:59+10:00' },
    { label: "Company All Time", from: '2023-04-01T00:00:00+10:00', to: new Date() },
  ]

  DateMode = DateMode;
  dateMode: DateMode = DateMode.Weekly
  dateOffset = 0;
  dateRange: DateRange = null;

  customDateRange: any = null;

  public COGS = COGS;
  public operatingExpenses = OperatingExpenses;
  public transactionPresets: TransactionPreset[] = [];

  public dataSource: MatTableDataSource<Transaction> = new MatTableDataSource();
  public selectedPresetName: string | null = null;
  public isApplyingPreset = false;
  private reloadAfterPresetsLoad = false;

  expenses: Transaction[] = [];
  revenues: Transaction[] = [];
  wages: Transaction[] = [];
  pendingRevenues: Transaction[] = [];

  expensesCategorizedType: any[] = [];
  expensesCategorisedBusiness: any[] = [];

  catIndex: any[] = [];
  activeCategory: string = "overview";
  activeExpenseCategory: string = "";

  atoCategorieTotals = [];
  totalExpenseExcl = 0;
  totalRevenueExcl = 0;
  totalRevenueIncl = 0
  totalExpenses = 0;

  totalProfit = 0;

  gstOnExpenses = 0;
  gstOnSales = 0;

  info: any = {
    count: 0,
    amount: 0,
    vat: 0
  };

  dataSourceOverview: MatTableDataSource<any> | undefined;
  expenseSubCategory: string;

  currentSearchQuery: string = null;
  sortOptions = [
    { value: 'date-desc', label: 'Date: Newest first' },
    { value: 'date-asc', label: 'Date: Oldest first' },
    { value: 'description-asc', label: 'Description: A-Z' },
    { value: 'description-desc', label: 'Description: Z-A' },
    { value: 'amount-desc', label: 'Amount: High to low' },
    { value: 'amount-asc', label: 'Amount: Low to high' }
  ];
  selectedSortOption = 'date-desc';
  showIgnoredTransactions = false;

  payrollerSummary: FinancialYearSummary | null = null;
  payrollerPayroll = {
    wagesPaid: 0,
    superPaid: 0,
    paygTaxPaid: 0
  };
  financialSummaryNotes = '';
  financialSummaryBas = {
    periodMode: 'quarterly' as BasPeriodMode,
    periods: [] as BasPeriodSummary[],
    totalSalesReported: 0,
    gstOnSalesReported: 0,
    gstOnExpensesReported: 0
  };
  basPeriodModes = [
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'monthly', label: 'Monthly' }
  ];
  payrollerReportTypes = [
    { type: 'payroll-summary', label: 'Payroll summary report' },
    { type: 'super-contribution', label: 'Super contribution report' }
  ];
  isLoadingPayrollerSummary = false;
  isSavingPayrollerSummary = false;
  uploadingPayrollerReportType = '';
  uploadingBasReportKey = '';
  payrollerSaveMessage = '';
  private payrollerAutosaveTimer: any = null;
  private savePayrollerSummaryAgain = false;

  accounts: any[] = [];

  constructor(
    private transactionService: TransactionsService,
    private bankService: BankService,
    public proofViewerDialogService: ProofViewerDialogService,
    public cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private accountService: AccountService,
    private pdfService: PDFService,
    private transactionPresetsService: TransactionPresetsService,
    private financialYearSummaryService: FinancialYearSummaryService,
    private appSettingsService: AppSettingsService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.currentSearchQuery = localStorage.getItem(this.searchStorageKey);
    this.selectedSortOption = localStorage.getItem(this.sortStorageKey) || this.selectedSortOption;

    this.route.data.subscribe(data => {

      if (data.tab == "expenses") {
        this.activeCategory = "expenses";

        const expenseParam = this.route.snapshot.paramMap?.get('expense');
        if (expenseParam) {
          this.loadBooks('expenses-business', expenseParam);
          this.loadPresets();
          return;
        }
      }

      if (data.tab == "revenue") {
        this.activeCategory = "revenue";
      }

      if (data.tab == "pending-revenue") {
        this.activeCategory = "pending-revenue";
      }

      if (data.tab == "wages") {
        this.activeCategory = "wages";
      }

      if (data.tab == "overview") {
        this.activeCategory = "overview";
      }

      if (data.tab == "payroller-summary") {
        this.activeCategory = "payroller-summary";
      }

    if (data.tab == "accounts") {
      this.activeCategory = "accounts";
    }

    this.loadBooks(this.activeCategory, this.activeExpenseCategory);
    this.reloadAfterPresetsLoad = true;
    this.loadPresets();
  });
}

  applyData(data: any) {
    if (this.dataSource == undefined) {
      this.dataSource = new MatTableDataSource();
    }

    const sortedData = this.sortTransactions(data || []);
    this.dataSource = new MatTableDataSource<Transaction>(sortedData);

    if (this.currentSearchQuery != null) {
      this.dataSource.filter = this.currentSearchQuery;
    }
  }

  changeSort(sortOption: string) {
    this.selectedSortOption = sortOption || 'date-desc';
    localStorage.setItem(this.sortStorageKey, this.selectedSortOption);

    if (!this.dataSource) {
      return;
    }

    this.dataSource.data = this.sortTransactions(this.dataSource.data || []);

    if (this.currentSearchQuery != null) {
      this.dataSource.filter = this.currentSearchQuery;
    }
  }

  private switchCategoryExpense(category: string) {
    
    if (category == "") {
      category = "expenses";
    }

    this.activeExpenseCategory = '';

    if (category == 'expenses') {
      this.updateInfo(this.expenses);
      this.applyData(this.expenses);

      if (this.activeCategory != 'expenses') {
        window.history.pushState({}, '', 'books/expenses');
      }
    }

    if (category != 'overview' && category != 'expenses' && category != 'wages') {
      this.expenseSubCategory = category;

      const catIndex = this.getCatIndex(category);
      const data = this.expensesCategorizedType[catIndex];

      if (this.activeExpenseCategory != category) {
        window.history.pushState({}, '', 'books/expenses/' + category);
      }

      this.updateInfo(data);
      this.applyData(data);
    }

    this.cdr.detectChanges();

    this.activeCategory = "expenses";

    if (category != 'expenses') {
      this.activeExpenseCategory = category;
    }
  }

  private switchCategoryExpenseByBusiness(business: string) {
    let data: Transaction[] = [];

    if (business == 'uncategorized') {
      for (let transaction of this.expenses) {
        if (transaction.supplier == null) {
          data.push(transaction);
        }
      }
    } else {
      for (let transaction of this.expenses) {
        if (transaction.supplier != null) {
          if (transaction.supplier.business == business) {
            data.push(transaction);
          }
        }
      }
    }

    this.updateInfo(data);
    this.applyData(data);

    window.history.pushState({}, '', 'books/expenses/' + business);
    
    this.activeCategory = 'expenses-business';
    this.activeExpenseCategory = business;
  }

  private switchCategoryExpenseByAto(category: string) {
    let data: Transaction[] = [];

    if (category == 'uncategorised') {
      for (let transaction of this.expenses) {
        if (transaction.atocategory == undefined) {
          data.push(transaction);
        }
      }      
    } else {
      for (let transaction of this.expenses) {
        if (transaction.atocategory == category) {
          data.push(transaction);
        }
      }
    }

    this.updateInfo(data);
    this.applyData(data);

    this.activeCategory = 'expenses-ato';
    this.activeExpenseCategory = category;
  }

  private updateInfo(data: Transaction[]) {

    if (data != undefined) {
      this.info.count = data.length;

      this.info.amount = 0;
      this.info.vat = 0;
      this.info.netGST = 0;

      for (let i of data) {
        this.info.amount += i.amount;
        this.info.vat += i.vat;
        this.info.netGST += i.amount - i.vat;
      }
    }
  }

  public accountExpensesAmount = 0;
  public accountRevenueAmount = 0;
  public wagesRevenueAmount = 0;
  public ATOWithholdingsAmount = 0;
  public superWithholdingsAmount = 0;

  private switchAccountView() {
    this.dataSource = new MatTableDataSource;
    window.history.pushState({}, '', 'books/accounts');

    this.accountService.find().subscribe((accounts: any) => {
      this.accounts = accounts;
      console.log(this.accounts)
      for (let account of accounts) {
        // Expenses
        if (account.accountNumber == "205386517") {
          this.accountExpensesAmount = account.balance;
        }

        // Revenue
        if (account.accountNumber == "480004229") {
          this.accountRevenueAmount = account.balance;
        }

        // Wages
        if (account.accountNumber == "425866854") {
          this.wagesRevenueAmount = account.balance;
        }

        // ATO Withholdings
        if (account.accountNumber == "453450661") {
          this.ATOWithholdingsAmount = account.balance;
        }

        // Super Withholdings
        if (account.accountNumber == "426179757") {
          this.superWithholdingsAmount = account.balance;
        }
      }

    })

    this.activeCategory = "accounts";
  }

  private switchCategoryOverview() {
    this.dataSource = new MatTableDataSource;
    
    if (this.activeCategory != "overview") {
      window.history.pushState({}, '', 'accounting-overview');
    } else {
      window.history.pushState({}, '', 'books/overview');
    }

    this.activeCategory = "overview";
  }

  private switchCategoryPayrollerSummary() {
    this.dataSource = new MatTableDataSource;
    window.history.pushState({}, '', 'books/financial-summary');
    this.activeCategory = "payroller-summary";
    this.loadPayrollerSummary();
  }

  private switchCategoryRevenue() {
    this.applyData(this.revenues);

    this.info.count = this.revenues.length;
    this.info.amount = 0;
    this.info.vat = 0;
    this.info.netGST = 0;

    for (let i of this.revenues) {
      this.info.amount += i.amount;
      this.info.vat += i.vat;
      this.info.netGST += i.amount - i.vat;
    }

    this.cdr.detectChanges();

    if (this.activeCategory != "revenue") {
      window.history.pushState({}, '', 'books/revenue');
    }

    this.activeCategory = "revenue"
  }

  private switchCategoryWages() {
    this.applyData(this.wages);
    this.cdr.detectChanges();

     window.history.pushState({}, '', 'books/wages');

    this.activeCategory = "wages";

    for (let transaction of this.wages) {
      this.info.amount += transaction.amount;
    }

    this.info.count = this.wages.length;
    this.info.vat = 0;
    this.info.netGST = 0;
  }

  private switchCategoryPendingRevenue() {
    this.applyData(this.pendingRevenues);
    this.cdr.detectChanges();

    if (this.activeCategory != "pending-revenue") {
      window.history.pushState({}, '', 'books/pending-revenue');
    }

    this.activeCategory = "pending-revenue";
  }

  toggleIgnoredTransactions() {
    this.showIgnoredTransactions = !this.showIgnoredTransactions;
    this.loadBooks(this.activeCategory, this.activeExpenseCategory);
  }

  loadBooks (category: string, subcategory: string = "") {

    this.dateRange = this.getDateRange();
    const queryDateRange = category === 'payroller-summary' && this.getPayrollerFinancialYearRange()
      ? this.getPayrollerFinancialYearRange()
      : this.dateRange;

    let query = {};
    let temp = {};

    query["source.account"] = { $in: [ACCOUNT.REVENUE, ACCOUNT.G72EXPENSES, ACCOUNT.EXPENSES, ACCOUNT.WAGES] }
    if (!this.showIgnoredTransactions) {
      query["ignore"] = { $in: [null, false] };
    }

    temp["$gte"] = queryDateRange.start;
    temp["$lte"] = queryDateRange.end;

    query["date"] = temp;

    this.transactionService.find(query, null, null, { "date": 1 }, this.showIgnoredTransactions).subscribe((transactions: Transaction[]) => {

      this.reset();

      for (let transaction of transactions) {
        switch (transaction.source.account) {
          case ACCOUNT.REVENUE:
            this.sortRevenue(transaction);
            break;
          case ACCOUNT.G72EXPENSES:
            this.sortExpense(transaction);
            break;
          case ACCOUNT.EXPENSES:
            this.sortExpense(transaction);
            break;
          case ACCOUNT.WAGES:
            this.sortWage(transaction);
            break;
        }
        
        if (transaction.source.account == ACCOUNT.REVENUE) {
          
        }
      };

      this.activeCategory = "overview";

      switch(category) {
        case "expenses":
            this.switchCategoryExpense(subcategory)
          break;
        case "expenses-ato":
            this.switchCategoryExpenseByAto(subcategory)
          break;
        case "expenses-business":
            this.switchCategoryExpenseByBusiness(subcategory);
            break;
        case "revenue":
          this.switchCategoryRevenue();
          break;
        case "wages":
          this.switchCategoryWages();
          break;
        case "overview":
          this.switchCategoryOverview();
          break;
        case "payroller-summary":
          this.switchCategoryPayrollerSummary();
          break;
        case "accounts":
          this.switchAccountView();
          break;
      }

    });
  }

  sortRevenue(transaction: Transaction) {
      if (transaction.amount > 0 || (this.showIgnoredTransactions && transaction.ignore)) {
        if (this.showIgnoredTransactions || !transaction.ignore) {
          this.revenues.push(transaction);
          const direction = transaction.amount < 0 ? -1 : 1;
          this.totalRevenueExcl += transaction.amount - direction * Math.abs(transaction.vat);
          this.totalRevenueIncl += transaction.amount;
          this.gstOnSales += direction * Math.abs(transaction.vat);
        }
    }
  }

  sortPendingRevenue(transactions: Transaction[]) {
    this.revenues = [];
    this.gstOnSales = 0;

    this.info.count = 0;
    this.info.amount = 0;
    this.info.vat = 0;

    for (let i = 0; i < transactions.length; i++) {
      if (transactions[i].amount > 0) {
        if (this.showIgnoredTransactions || !transactions[i].ignore) {
          this.pendingRevenues.push(transactions[i]);

          this.info.amount += transactions[i].amount - transactions[i].vat;
          this.info.vat += transactions[i].vat;
          this.info.count++;
        }
      }
    }

    if (this.currentSearchQuery != null) {
      this.dataSource.filter = this.currentSearchQuery;
    }

    if (this.activeCategory == "pending-revenue") {
      this.switchCategoryPendingRevenue();
    }
  }

  sortExpense(transaction: Transaction) {

    this.expenses.push(transaction);

    this.setCatIndex(transaction["atocategory"]);

    let catIndex = this.getCatIndex(transaction["atocategory"]);

    if (this.expensesCategorizedType[catIndex] == undefined) {
      this.expensesCategorizedType[catIndex] = [];
    }

    this.expensesCategorizedType[catIndex].push(transaction);

    if (transaction.amount < 0) {
      // Do the GST part
      if (transaction.vat) {
        this.totalExpenseExcl -= transaction.amount - (transaction.amount / 11);
        this.gstOnExpenses += Math.abs(transaction.amount / 11);
      } else {
        this.totalExpenseExcl -= transaction.amount;
      }

      this.totalExpenses += transaction.amount;
    }

    for (let category in this.expensesCategorizedType) {
      let count = 0;
      let amount = 0;
      let vat = 0;
      let netGST = 0;
      for (let x of this.expensesCategorizedType[category]) {
        // Do the GST part
        if (x.vat) {
          netGST += x.amount - (x.amount / 11);

          vat += (x.amount / 11);
        } else {
          netGST += x.amount;
        }

        amount += x.amount;
        count++;
      }

      this.atoCategorieTotals.push({
        label: this.getCategoryName(this.catIndex[category]),
        count: count,
        category: this.catIndex[category],
        amount: amount,
        vat: vat,
        netGST: netGST
      });
    }

    let check = 0;
    for (let x of this.atoCategorieTotals) {
      check += x.amount;
    }

    let categories = [{ label: "Uncategorised", value: "uncategorised" }, ...this.COGS, ...this.operatingExpenses];

    let sorted: any[] = [];
    for (let i = 0; i < this.atoCategorieTotals.length; i++) {
      for (let x = 0; x < categories.length; x++) {
        if (this.atoCategorieTotals[i].category == categories[x].value) {
          sorted[x] = this.atoCategorieTotals[i];
        }
      }
    }

    let sortedAgain = [];
    for (let x of sorted) {
      if (x != undefined) {
        sortedAgain.push(x);
      }
    }

    this.atoCategorieTotals = sortedAgain;

    transaction.supplier = this.autoSort(transaction);

    if (transaction.supplier != null) {
      // Add to business category listing
      let found = false;
      for (let i=0; i < this.expensesCategorisedBusiness.length; i++) {
        if (this.expensesCategorisedBusiness[i].label == transaction.supplier.business) {
          this.expensesCategorisedBusiness[i].transactions.push(transaction);
          found = true;
          break;
        }
      }

      if (!found) {
        this.expensesCategorisedBusiness.push({
          label: transaction.supplier.business,
          transactions: [ transaction ]
        });
      }
    }
  }

  sortWage(transaction: Transaction) {

    if (transaction.amount < 0 || (this.showIgnoredTransactions && transaction.ignore)) {
      this.wages.push(transaction);
    }
  }

  setCatIndex(category: string | undefined) {
    if (category == undefined) {
      category = "uncategorised"
    }

    // Check if category already exists
    for (let cat of this.catIndex) {
      if (cat == category) {
        return;
      }
    }

    this.catIndex.push(category);
  }

  getCatIndex(category: string | undefined) {
    if (category == undefined) {
      category = "uncategorised";
    }

    for (let i = 0; i < this.catIndex.length; i++) {
      if (this.catIndex[i] == category) {
        return i;
      }
    }
  }

  reset () {
    this.revenues = [];
    this.expenses = [];
    this.wages = [];
    this.pendingRevenues = [];

    this.info.count = 0;
    this.info.amount = 0;
    this.info.vat = 0;

    this.catIndex = [];

    this.atoCategorieTotals = [];
    this.totalExpenseExcl = 0;
    this.totalRevenueExcl = 0;
    this.totalRevenueIncl = 0;
    this.totalProfit = 0;

    this.totalExpenses = 0;
    this.gstOnExpenses = 0;
    this.gstOnSales = 0;

    this.expensesCategorizedType = [];
    this.expensesCategorisedBusiness = [];
  }

  openTransactionDialog(transaction: Transaction, index: number) {
    this.transactionService.openTransactionDialog(this.transactionService.getTransactionType(transaction), transaction.source.sha1, index, this.dataSource, (r: any) => {     
      this.loadBooks(this.activeCategory, this.activeExpenseCategory);
    });
  }

  openPresetManager() {
    const ref = this.dialog.open(TransactionPresetDialogComponent, {
      width: '1200px',
      panelClass: 'dialog-test'
    });

    ref.afterClosed().subscribe(() => {
      this.loadPresets();
    });
  }

  private loadPresets(onComplete?: () => void) {
    this.transactionPresetsService.list().subscribe(presets => {
      this.transactionPresets = presets;
      if (!this.selectedPresetName && this.transactionPresets.length) {
        this.selectedPresetName = this.transactionPresets[0].name;
      }
      this.cdr.detectChanges();
      if (this.reloadAfterPresetsLoad) {
        this.reloadAfterPresetsLoad = false;
        this.loadBooks(this.activeCategory, this.activeExpenseCategory);
      }
      onComplete?.();
    }, () => {
      this.transactionPresets = [];
      this.reloadAfterPresetsLoad = false;
      onComplete?.();
    });
  }

  getCategoryName(category: string) {

    if (category == "uncategorised") {
      return "Uncategorised";
    }

    for (let cat of this.COGS) {
      if (category == cat.value) {
        return cat.label
      }
    }

    for (let cat of this.operatingExpenses) {
      if (category == cat.value) {
        return cat.label
      }
    }

    return category;
  }

  getLabel() {
    switch (this.dateMode) {
      case DateMode.Weekly:
        return ["Previous Week", "Next Week"];
      case DateMode.Monthly:
        return ["Previous Month", "Next Month"];
      case DateMode.Quaterly:
        return ["Previous Quater", "Next Quater"];
      case DateMode.Yearly:
        return ["Previous Year", "Next Year"];
      case DateMode.AllTime:
        return ["", ""];
      case DateMode.Custom:
        return null;
    }
  }


  switchToCustomDateRange(range: any) {
    this.dateMode = DateMode.Custom;
    this.customDateRange = range;
    this.dateRange = {
      start: range.from,
      end: range.to
    }

    this.reloadCurrentView();
  }

  cancelCustom() {
    this.switchToWeekly();
  }

  nextDateRange() {
    if (this.dateOffset > 0) {
      this.dateOffset--;
      this.findDateRange(this.dateMode, this.dateOffset);

      this.reloadCurrentView();
    }
  }

  previousDateRange() {
    if (this.isPreviousDateRangeDisabled()) {
      return;
    }

    this.dateOffset++;

    this.findDateRange(this.dateMode, this.dateOffset);
    this.reloadCurrentView();
  }

  getDateRange() {
    // Lets do some local storage fuckery here
    let dateRange = localStorage.getItem("booksDateRange");

    if (dateRange == null) {
      this.findDateRange(DateMode.Weekly, 0);
    }

    const temp = JSON.parse(localStorage.getItem("booksDateRange"));

    this.dateOffset = temp.offset == null ? 0 : +temp.offset;
    this.dateMode = temp.dateMode == null ? 0 : +temp.dateMode;

    const range = this.clampDateRangeToBookkeepingStart(
      new Date(temp.start),
      new Date(temp.end)
    );

    return {
      ...range
    };
  }

  private getBookkeepingStartDate() {
    const configuredDate = this.appSettingsService.getBookkeepingStartDate();

    if (!configuredDate) {
      return null;
    }

    const startDate = new Date(configuredDate);

    if (Number.isNaN(startDate.getTime())) {
      return null;
    }

    startDate.setHours(0, 0, 0, 0);
    return startDate;
  }

  private clampDateRangeToBookkeepingStart(startDate: Date, endDate: Date) {
    const bookkeepingStartDate = this.getBookkeepingStartDate();

    if (bookkeepingStartDate && startDate < bookkeepingStartDate) {
      startDate = new Date(bookkeepingStartDate);
    }

    return {
      start: startDate,
      end: endDate
    };
  }

  isPreviousDateRangeDisabled() {
    const bookkeepingStartDate = this.getBookkeepingStartDate();

    if (!bookkeepingStartDate || !this.dateRange) {
      return false;
    }

    if (this.dateMode === DateMode.AllTime) {
      return true;
    }

    const currentStart = new Date(this.dateRange.start);
    currentStart.setHours(0, 0, 0, 0);

    return currentStart <= bookkeepingStartDate;
  }

  setDateRange(startDate: Date, endDate: Date, dateMode: DateMode, offset: number) {
    const range = this.clampDateRangeToBookkeepingStart(startDate, endDate);

    localStorage.setItem("booksDateRange", JSON.stringify({
      start: range.start,
      end: range.end,
      dateMode: dateMode,
      offset: offset
    }));
  }

  findDateRange(dateMode: DateMode, dateOffset: number) {
    switch (dateMode) {
      case DateMode.Weekly:
        this.getWeekRange(dateOffset);
        break;
      case DateMode.Monthly:
        this.getMonthlyRange(dateOffset);
        break;
      case DateMode.Quaterly:
        this.getQuaterlyRange(dateOffset);
        break;
      case DateMode.Yearly:
        console.log("hit")
        this.getYearlyRange(dateOffset);
        break;
      case DateMode.AllTime:
        this.getAllTimeRange();
    }
  }

  getMonthlyRange(monthOffset: number) {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() - monthOffset;

    // Calculate the year and month, accounting for offset
    const targetYear = year + Math.floor(month / 12);
    const targetMonth = (month % 12 + 12) % 12; // Ensure the month is in the range 0-11

    // Calculate the number of days in the target month
    const numDays = new Date(targetYear, targetMonth + 1, 0).getDate();

    // Calculate the start and end dates of the month
    const startDate = new Date(targetYear, targetMonth, 1);
    const endDate = new Date(targetYear, targetMonth, numDays);

    this.setDateRange(startDate, endDate, DateMode.Monthly, monthOffset)
  }

  getYearlyRange(yearOffset: number) {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const targetYear = currentYear - yearOffset;
    
    // Determine if we are before the end of the finacial year or after
    if (currentDate.getMonth() > 6) {
      // Calculate the start and end dates of the target year
      this.setDateRange(
        new Date(targetYear, 6, 1),
        new Date(targetYear + 1, 5, 30),
        DateMode.Yearly,
        yearOffset
      );

    } else {
      // Calculate the start and end dates of the target year
      this.setDateRange(
        new Date(targetYear - 1, 6, 1),
        new Date(targetYear, 5, 30),
        DateMode.Yearly,
        yearOffset
      );
    }
  }


  getQuaterlyRange(dateOffset = 0) {
    const now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth(); // 0-11 (Jan-Dec)
    
    // Adjust for the offset (each offset is 3 months)
    month -= dateOffset * 3;
    
    // Handle year wrapping when going backwards
    while (month < 0) {
      month += 12;
      year--;
    }
    
    // Determine financial quarter (FY starts July)
    let quarter;
    let quarterStartMonth;
    
    if (month >= 6 && month <= 8) { // July-Sept (Q1)
      quarter = 1;
      quarterStartMonth = 6; // July (0-based)
    } else if (month >= 9 && month <= 11) { // Oct-Dec (Q2)
      quarter = 2;
      quarterStartMonth = 9; // October (0-based)
    } else if (month >= 0 && month <= 2) { // Jan-Mar (Q3)
      quarter = 3;
      quarterStartMonth = 0; // January (0-based)
    } else { // Apr-Jun (Q4)
      quarter = 4;
      quarterStartMonth = 3; // April (0-based)
    }
    
    // Calculate start and end dates of the quarter
    const startDate = new Date(year, quarterStartMonth, 1);
    let endDate;
    
    if (quarter === 1 || quarter === 2) {
      // For Q1 (Jul-Sep) and Q2 (Oct-Dec), end date is last day of month
      endDate = new Date(year, quarterStartMonth + 2, 
        quarter === 1 ? 30 : 31); // Sep 30 or Dec 31
    } else if (quarter === 3) {
      // Q3 (Jan-Mar) ends Mar 31
      endDate = new Date(year, 2, 31);
    } else {
      // Q4 (Apr-Jun) ends Jun 30
      endDate = new Date(year, 5, 30);
    }
    
    // Set end time to 23:59:59
    endDate.setHours(23, 59, 59, 999);
    
    this.setDateRange(
      startDate, 
      endDate,
      DateMode.Quaterly,
      dateOffset);
  }

  getQuaterlyRangeOld(dateOffset: number) {
    const date = new Date();

    const currentMonth = new Date().getMonth() + 1; // Get the current month (0 - 11)
    console.log(currentMonth)
    let adjustedMonth = (currentMonth - (dateOffset * 3)) % 12; // Apply the offset and ensure it stays within 0-11

    if (adjustedMonth <= 0) {
      adjustedMonth += 12; // Adjust to the appropriate month (0 - 11)
    }
    console.log(adjustedMonth)

    const currentQuarter = {
      1: 3, // January
      2: 3, // February
      3: 3, // March

      4: 4, // April
      5: 4, // May
      6: 4, // June

      7: 1, // July
      8: 1, // August
      9: 1, // September

      10: 2, // October
      11: 2, // November
      12: 2, // December
    }[adjustedMonth];

    const offsetQuater = {
      1: 0, // January
      2: 0, // February
      3: 0, // March

      4: 1, // April
      5: 1, // May
      6: 1, // June

      7: 2, // July
      8: 2, // August
      9: 2, // September

      10: 3, // October
      11: 3, // November
      12: 3, // December
    }[adjustedMonth];

    dateOffset = Math.floor(((dateOffset + offsetQuater) / 4))

    let currentYear = date.getFullYear() - dateOffset;

    const quater = {
      // First Quater
      1: {
        start: new Date(currentYear + "-07-01T00:00:00+10:00"),
        end: new Date(currentYear + "-09-30T23:23:59+10:00")
      },
      2: {
        start: new Date(currentYear + "-10-01T00:00:00+10:00"),
        end: new Date(currentYear + "-12-30T23:23:59+10:00")
      },
      3: {
        start: new Date(currentYear + "-01-01T00:00:00+10:00"),
        end: new Date(currentYear + "-03-31T23:23:59+10:00")
      },
      4: {
        start: new Date(currentYear + "-04-01T00:00:00+10:00"),
        end: new Date(currentYear + "-06-31T23:23:59+10:00")
      }
    }[currentQuarter]

    this.setDateRange(
      quater.start, 
      quater.end,
      DateMode.Quaterly,
      offsetQuater);
  }

  getWeekRange(weekOffset: number) {
    let date = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 7 * weekOffset))

    let first = setToMonday(date);
    first.setHours(0, 0, 0, 0);

    let last = new Date(first.getTime());
    last.setDate(first.getDate() + 6); // last day is the first day + 6
    last.setHours(23, 59, 59);
    console.log(weekOffset)
    this.setDateRange(
      first, 
      last,
      DateMode.Weekly,
      weekOffset
    );
  }

  getAllTimeRange() {
    this.setDateRange(
      new Date("1970-01-01"),
      new Date(),
      DateMode.AllTime,
      0
    )
  }

  switchToWeekly() {
    this.dateOffset = 0;
    this.dateMode = DateMode.Weekly;
    this.findDateRange(DateMode.Weekly, this.dateOffset);
    this.reloadCurrentView();
  }

  switchToMonthly() {
    this.dateOffset = 0;
    this.dateMode = DateMode.Monthly;
    this.findDateRange(DateMode.Monthly, this.dateOffset);
    this.reloadCurrentView();
  }

  switchToQuaterly() {
    this.dateOffset = 0;
    this.dateMode = DateMode.Quaterly;
    this.findDateRange(DateMode.Quaterly, this.dateOffset);
    this.reloadCurrentView();
  }

  switchToYearly() {
    this.dateOffset = 0;
    this.dateMode = DateMode.Yearly;
    this.findDateRange(DateMode.Yearly, this.dateOffset);
    this.reloadCurrentView();
  }

  switchToAllTime() {
    this.dateOffset = 0;
    this.dateMode = DateMode.AllTime;
    this.findDateRange(DateMode.AllTime, this.dateOffset);
    this.reloadCurrentView();
  }

  private reloadCurrentView() {
    this.loadBooks(this.activeCategory, this.activeExpenseCategory);
  }

  search(query: string) {
    this.currentSearchQuery = query;
    this.dataSource.filter = query;
    localStorage.setItem(this.searchStorageKey, query);
  }

  searchCancelled() {
    this.currentSearchQuery = null;
    this.dataSource.filter = null;
    localStorage.removeItem(this.searchStorageKey);
  }

  private sortTransactions(data: Transaction[]) {
    const [field, direction] = (this.selectedSortOption || 'date-desc').split('-');
    const modifier = direction === 'desc' ? -1 : 1;

    return [...data].sort((a, b) => {
      switch (field) {
        case 'description':
          return this.compareStrings(a?.description, b?.description) * modifier;
        case 'amount':
          return this.compareNumbers(a?.amount, b?.amount) * modifier;
        case 'date':
        default:
          return this.compareNumbers(this.toTimestamp(a?.date), this.toTimestamp(b?.date)) * modifier;
      }
    });
  }

  private compareStrings(a: string | null | undefined, b: string | null | undefined) {
    return (a || '').localeCompare(b || '', undefined, { sensitivity: 'base' });
  }

  private compareNumbers(a: number | null | undefined, b: number | null | undefined) {
    return (a || 0) - (b || 0);
  }

  private toTimestamp(value: Date | string | null | undefined) {
    if (!value) {
      return 0;
    }

    const date = value instanceof Date ? value : new Date(value);
    const timestamp = date.getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
  }

  getPayrollerFinancialYearRange() {
    if (!this.dateRange || this.dateMode === DateMode.AllTime) {
      return null;
    }

    const selected = new Date(this.dateRange.start);
    const year = selected.getFullYear();
    const financialYearStart = selected.getMonth() >= 6 ? year : year - 1;

    return {
      start: new Date(financialYearStart, 6, 1, 0, 0, 0, 0),
      end: new Date(financialYearStart + 1, 5, 30, 23, 59, 59, 999)
    };
  }

  getPayrollerFinancialYearKey() {
    const range = this.getPayrollerFinancialYearRange();

    if (!range) {
      return '';
    }

    return `${range.start.getFullYear()}-${range.end.getFullYear()}`;
  }

  getCurrentFinancialYearKey() {
    const now = new Date();
    const year = now.getFullYear();
    const financialYearStart = now.getMonth() >= 6 ? year : year - 1;

    return `${financialYearStart}-${financialYearStart + 1}`;
  }

  isCurrentPayrollerFinancialYear() {
    const financialYear = this.getPayrollerFinancialYearKey();
    return financialYear !== '' && financialYear === this.getCurrentFinancialYearKey();
  }

  isPayrollerSummaryAvailable() {
    return this.getPayrollerFinancialYearRange() !== null && !this.isCurrentPayrollerFinancialYear();
  }

  getPayrollerSummaryWarning() {
    if (this.dateMode === DateMode.AllTime) {
      return 'Select a specific week, month, quarter, year, or custom range so the payroll summary can lock to the correct financial year.';
    }

    if (this.isCurrentPayrollerFinancialYear()) {
      return 'Current financial year is still in progress. Payroll summary entry will unlock after the financial year closes.';
    }

    return '';
  }

  loadPayrollerSummary() {
    const financialYear = this.getPayrollerFinancialYearKey();
    this.payrollerSaveMessage = '';

    if (!financialYear) {
      this.payrollerSummary = null;
      this.payrollerPayroll = {
        wagesPaid: 0,
        superPaid: 0,
        paygTaxPaid: 0
      };
      this.financialSummaryNotes = '';
      this.financialSummaryBas = {
        periodMode: 'quarterly',
        periods: [],
        totalSalesReported: 0,
        gstOnSalesReported: 0,
        gstOnExpensesReported: 0
      };
      return;
    }

    this.isLoadingPayrollerSummary = true;

    this.financialYearSummaryService.get(financialYear).subscribe((summary) => {
      this.payrollerSummary = summary;
      this.payrollerPayroll = {
        wagesPaid: summary?.payroll?.wagesPaid || 0,
        superPaid: summary?.payroll?.superPaid || 0,
        paygTaxPaid: summary?.payroll?.paygTaxPaid || 0
      };
      this.financialSummaryNotes = summary?.notes || summary?.payroll?.notes || '';
      this.financialSummaryBas = {
        periodMode: this.getBasPeriodMode(summary),
        periods: this.buildBasPeriods(this.getBasPeriodMode(summary), summary?.bas?.periods || []),
        totalSalesReported: summary?.bas?.totalSalesReported || 0,
        gstOnSalesReported: summary?.bas?.gstOnSalesReported || 0,
        gstOnExpensesReported: summary?.bas?.gstOnExpensesReported || 0
      };
      this.isLoadingPayrollerSummary = false;
      this.cdr.detectChanges();
    }, () => {
      this.isLoadingPayrollerSummary = false;
      this.payrollerSaveMessage = 'Could not load payroll summary.';
      this.cdr.detectChanges();
    });
  }

  savePayrollerSummary() {
    if (this.payrollerAutosaveTimer != null) {
      clearTimeout(this.payrollerAutosaveTimer);
      this.payrollerAutosaveTimer = null;
    }

    const financialYear = this.getPayrollerFinancialYearKey();
    const range = this.getPayrollerFinancialYearRange();

    if (!financialYear || !range || !this.isPayrollerSummaryAvailable()) {
      return;
    }

    if (this.isSavingPayrollerSummary) {
      this.savePayrollerSummaryAgain = true;
      return;
    }

    const summary: FinancialYearSummary = {
      ...(this.payrollerSummary || {}),
      financialYear,
      startDate: range.start,
      endDate: range.end,
      notes: this.financialSummaryNotes || '',
      bas: {
        ...(this.payrollerSummary?.bas || {}),
        periodMode: this.financialSummaryBas.periodMode,
        periods: this.financialSummaryBas.periods,
        totalSalesReported: this.getBasReportedTotal('totalSalesReported'),
        gstOnSalesReported: this.getBasReportedTotal('gstOnSalesReported'),
        gstOnExpensesReported: this.getBasReportedTotal('gstOnExpensesReported')
      },
      payroll: {
        ...(this.payrollerSummary?.payroll || {}),
        wagesPaid: this.payrollerPayroll.wagesPaid || 0,
        superPaid: this.payrollerPayroll.superPaid || 0,
        paygTaxPaid: this.payrollerPayroll.paygTaxPaid || 0
      }
    };

    this.isSavingPayrollerSummary = true;
    this.payrollerSaveMessage = '';

    this.financialYearSummaryService.update(summary).subscribe((updated) => {
      this.payrollerSummary = updated;
      this.isSavingPayrollerSummary = false;
      this.payrollerSaveMessage = 'Financial summary saved.';
      if (this.savePayrollerSummaryAgain) {
        this.savePayrollerSummaryAgain = false;
        this.queuePayrollerSummarySave();
      }
      this.cdr.detectChanges();
    }, () => {
      this.isSavingPayrollerSummary = false;
      this.payrollerSaveMessage = 'Could not save payroll summary.';
      this.cdr.detectChanges();
    });
  }

  queuePayrollerSummarySave() {
    if (!this.isPayrollerSummaryAvailable() || this.isLoadingPayrollerSummary) {
      return;
    }

    if (this.payrollerAutosaveTimer != null) {
      clearTimeout(this.payrollerAutosaveTimer);
    }

    this.payrollerSaveMessage = 'Saving changes...';
    this.payrollerAutosaveTimer = setTimeout(() => this.savePayrollerSummary(), 600);
  }

  getBasPeriodMode(summary: FinancialYearSummary | null): BasPeriodMode {
    return summary?.bas?.periodMode === 'monthly' ? 'monthly' : 'quarterly';
  }

  setBasPeriodMode(periodMode: BasPeriodMode) {
    this.financialSummaryBas.periodMode = periodMode;
    this.financialSummaryBas.periods = this.buildBasPeriods(periodMode, this.financialSummaryBas.periods);
    this.queuePayrollerSummarySave();
  }

  buildBasPeriods(periodMode: BasPeriodMode, existingPeriods: BasPeriodSummary[] = []): BasPeriodSummary[] {
    const range = this.getPayrollerFinancialYearRange();

    if (!range) {
      return [];
    }

    const existingByKey = new Map(existingPeriods.map(period => [period.periodKey, period]));
    const periods: BasPeriodSummary[] = [];
    const startYear = range.start.getFullYear();
    const definitions = periodMode === 'monthly'
      ? this.getBasMonthlyPeriodDefinitions(startYear)
      : this.getBasQuarterlyPeriodDefinitions(startYear);

    for (let definition of definitions) {
      const existing = existingByKey.get(definition.periodKey);
      periods.push({
        ...definition,
        totalSalesReported: existing?.totalSalesReported || 0,
        gstOnSalesReported: existing?.gstOnSalesReported || 0,
        gstOnExpensesReported: existing?.gstOnExpensesReported || 0,
        report: existing?.report
      });
    }

    return periods;
  }

  private getBasMonthlyPeriodDefinitions(startYear: number): BasPeriodSummary[] {
    const periods = [];

    for (let index = 0; index < 12; index++) {
      const month = (6 + index) % 12;
      const year = index < 6 ? startYear : startYear + 1;
      const startDate = new Date(year, month, 1, 0, 0, 0, 0);
      const endDate = new Date(year, month + 1, 0, 23, 59, 59, 999);
      periods.push(this.createBasPeriodDefinition('monthly', `${year}-${String(month + 1).padStart(2, '0')}`, startDate.toLocaleString('en-AU', { month: 'short', year: 'numeric' }), startDate, endDate));
    }

    return periods;
  }

  private getBasQuarterlyPeriodDefinitions(startYear: number): BasPeriodSummary[] {
    return [
      this.createBasPeriodDefinition('quarterly', `${startYear}-q1`, `Q1 Jul-Sep ${startYear}`, new Date(startYear, 6, 1, 0, 0, 0, 0), new Date(startYear, 8, 30, 23, 59, 59, 999)),
      this.createBasPeriodDefinition('quarterly', `${startYear}-q2`, `Q2 Oct-Dec ${startYear}`, new Date(startYear, 9, 1, 0, 0, 0, 0), new Date(startYear, 11, 31, 23, 59, 59, 999)),
      this.createBasPeriodDefinition('quarterly', `${startYear + 1}-q3`, `Q3 Jan-Mar ${startYear + 1}`, new Date(startYear + 1, 0, 1, 0, 0, 0, 0), new Date(startYear + 1, 2, 31, 23, 59, 59, 999)),
      this.createBasPeriodDefinition('quarterly', `${startYear + 1}-q4`, `Q4 Apr-Jun ${startYear + 1}`, new Date(startYear + 1, 3, 1, 0, 0, 0, 0), new Date(startYear + 1, 5, 30, 23, 59, 59, 999))
    ];
  }

  private createBasPeriodDefinition(periodType: BasPeriodMode, periodKey: string, label: string, startDate: Date, endDate: Date): BasPeriodSummary {
    return {
      periodType,
      periodKey,
      label,
      startDate,
      endDate,
      totalSalesReported: 0,
      gstOnSalesReported: 0,
      gstOnExpensesReported: 0
    };
  }

  updateBasPeriod(period: BasPeriodSummary, field: 'totalSalesReported' | 'gstOnSalesReported' | 'gstOnExpensesReported', amount: number) {
    period[field] = amount || 0;
    this.queuePayrollerSummarySave();
  }

  getBasReportedTotal(field: 'totalSalesReported' | 'gstOnSalesReported' | 'gstOnExpensesReported') {
    if (!this.financialSummaryBas.periods.length) {
      return this.financialSummaryBas[field] || 0;
    }

    return this.financialSummaryBas.periods.reduce((total, period) => total + (period[field] || 0), 0);
  }

  getBasPeriodCurrentTotal(period: BasPeriodSummary, field: 'totalSales' | 'gstOnSales' | 'gstOnExpenses') {
    const startDate = new Date(period.startDate);
    const endDate = new Date(period.endDate);
    let total = 0;

    if (field === 'totalSales' || field === 'gstOnSales') {
      for (let transaction of this.revenues) {
        const transactionDate = new Date(transaction.date);
        if (transactionDate >= startDate && transactionDate <= endDate) {
          total += field === 'totalSales' ? Math.abs(transaction.amount) : Math.abs(transaction.vat || 0);
        }
      }
    }

    if (field === 'gstOnExpenses') {
      for (let transaction of this.expenses) {
        const transactionDate = new Date(transaction.date);
        if (transaction.amount < 0 && transaction.vat && transactionDate >= startDate && transactionDate <= endDate) {
          total += Math.abs(transaction.amount / 11);
        }
      }
    }

    return total;
  }

  isBasMatch(current: number, reported: number) {
    return Math.round(current || 0) === Math.round(reported || 0);
  }

  getFinancialYearReportUrl(report: FinancialYearAttachment) {
    return this.financialYearSummaryService.getReportURL(report);
  }

  uploadBasReport(event: Event, period: BasPeriodSummary) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';

    if (!file || !this.isPayrollerSummaryAvailable() || this.uploadingBasReportKey) {
      return;
    }

    const financialYear = this.getPayrollerFinancialYearKey();
    const range = this.getPayrollerFinancialYearRange();

    if (!financialYear || !range) {
      return;
    }

    this.savePayrollerSummary();
    this.uploadingBasReportKey = period.periodKey;
    this.payrollerSaveMessage = `Uploading ${period.label} BAS report...`;

    this.financialYearSummaryService.uploadReport(financialYear, range, 'bas-report', `${period.label} BAS report`, file, 'bas', period.periodKey).subscribe((summary) => {
      this.payrollerSummary = summary;
      this.financialSummaryBas = {
        ...this.financialSummaryBas,
        periodMode: this.getBasPeriodMode(summary),
        periods: this.buildBasPeriods(this.getBasPeriodMode(summary), summary?.bas?.periods || [])
      };
      this.uploadingBasReportKey = '';
      this.payrollerSaveMessage = `${period.label} BAS report uploaded.`;
      this.cdr.detectChanges();
    }, () => {
      this.uploadingBasReportKey = '';
      this.payrollerSaveMessage = `Could not upload ${period.label} BAS report.`;
      this.cdr.detectChanges();
    });
  }

  getPayrollerReport(type: string): FinancialYearAttachment | null {
    return this.payrollerSummary?.payroll?.reports?.find(report => report.type === type) || null;
  }

  getPayrollerReportUrl(report: FinancialYearAttachment) {
    return this.financialYearSummaryService.getReportURL(report);
  }

  uploadPayrollerReport(event: Event, reportType: { type: string; label: string }) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';

    if (!file || !this.isPayrollerSummaryAvailable() || this.uploadingPayrollerReportType) {
      return;
    }

    const financialYear = this.getPayrollerFinancialYearKey();
    const range = this.getPayrollerFinancialYearRange();

    if (!financialYear || !range) {
      return;
    }

    this.uploadingPayrollerReportType = reportType.type;
    this.payrollerSaveMessage = `Uploading ${reportType.label}...`;

    this.financialYearSummaryService.uploadReport(financialYear, range, reportType.type, reportType.label, file).subscribe((summary) => {
      this.payrollerSummary = summary;
      this.uploadingPayrollerReportType = '';
      this.payrollerSaveMessage = `${reportType.label} uploaded.`;
      this.cdr.detectChanges();
    }, () => {
      this.uploadingPayrollerReportType = '';
      this.payrollerSaveMessage = `Could not upload ${reportType.label}.`;
      this.cdr.detectChanges();
    });
  }

  report() {
    const financialYear = this.getPayrollerFinancialYearKey();

    if (financialYear) {
      this.financialYearSummaryService.get(financialYear).subscribe((summary) => {
        this.openFinancialReport(summary);
      }, () => {
        this.openFinancialReport();
      });
      return;
    }

    this.openFinancialReport();
  }

  private openFinancialReport(summary?: FinancialYearSummary | null) {
    let temp = [];
    for (let x of this.atoCategorieTotals) {
      temp.push({
        label: x.label,
        amount: human(Math.abs(x.netGST), true, true)
      })
    }

    const payroll = summary?.payroll || this.payrollerSummary?.payroll || this.payrollerPayroll;
    const wagesPaid = Math.abs(payroll?.wagesPaid || 0);
    const superPaid = Math.abs(payroll?.superPaid || 0);
    const paygTaxPaid = Math.abs(payroll?.paygTaxPaid || 0);
    const netProfit = this.totalRevenueExcl - this.totalExpenseExcl - wagesPaid - superPaid;

    this.pdfService.openPDFDialog("finacial-report", {
      // expenses: this.expenses,
      // revenues: this.revenues,
      // wages: this.wages,

      // expensesCategorized: this.expensesCategorized,
      dateCreated: new Date(),
      dateRange: this.dateRange,
      atoCategorieTotals: temp,
      totalExpenseExcl: human(Math.abs(this.totalExpenseExcl), true, true),
      totalRevenueExcl: human(this.totalRevenueExcl, true, true),
      totalRevenueIncl: human(this.totalRevenueIncl, true, true),
      totalExpenses: human(Math.abs(this.totalExpenses), true, true),
      wagesPaid: human(wagesPaid, true, true),
      paygTaxPaid: human(paygTaxPaid, true, true),
      superPaid: human(superPaid, true, true),
      netProfit: human(netProfit, true, true),

      gstOnExpenses: this.gstOnExpenses,
      gstOnSales: this.gstOnSales
    }, (r) => {

    });
  }

  autoSort(transaction: Transaction) {
    const explicitPresetName = transaction.preset || transaction.subcategory;
    const explicitPreset = this.getPresetByName(explicitPresetName);

    if (explicitPreset) {
      return {
        business: explicitPreset.name,
        date: transaction.supplier?.date || "",
        order: transaction.supplier?.order || ""
      };
    }

    if (!transaction.description) {
      return null;
    }

    for (const preset of this.transactionPresets) {
      for (const pattern of (preset.patterns || [])) {
        const regex = this.buildPatternRegex(pattern);
        if (!regex) continue;

        const match = regex.exec(transaction.description);
        if (match) {
          const fancy = {
            business: preset.name,
            date: "",
            order: ""
          }

          if (match.groups != undefined) {
            if (match.groups.date != undefined) {
              fancy.date = match.groups.date;
            }

            if (match.groups.order != undefined) {
              fancy.order = match.groups.order;
            }
          }

          return fancy;
        }
      }
    }

    return null;
  }

  private buildPatternRegex(pattern: { pattern: string; flags?: string }) {
    if (!pattern?.pattern) return null;
    try {
      return new RegExp(pattern.pattern, pattern.flags || '');
    } catch (e) {
      console.warn('Invalid preset regex', pattern, e);
      return null;
    }
  }

  private getPresetByName(name: string | null | undefined): TransactionPreset | undefined {
    if (!name) {
      return undefined;
    }
    return this.transactionPresets.find(p => p.name === name);
  }

  canApplyPreset() {
    return !!this.getPresetByName(this.selectedPresetName) && !!(this.dataSource?.filteredData?.length) && !this.isApplyingPreset;
  }

  useBusinessPreset() {
    if (!this.canAutoSortTransactions()) {
      return;
    }
    this.selectedPresetName = this.activeExpenseCategory;
    this.applyPresetToFiltered();
  }

  applyPresetToFiltered() {
    const preset = this.getPresetByName(this.selectedPresetName);
    const transactions: Transaction[] = this.dataSource?.filteredData || [];

    if (!preset || !transactions.length) {
      return;
    }

    this.isApplyingPreset = true;

    forkJoin(transactions.map(transaction => this.applyPreset(preset, transaction))).pipe(
      finalize(() => this.isApplyingPreset = false)
    ).subscribe(() => {
      this.loadBooks(this.activeCategory, this.activeExpenseCategory);
    }, () => {
      // Keep UI enabled even if one update failed
    });
  }

  applyPreset(preset: TransactionPreset, transaction: Transaction) {
    transaction.preset = preset.name;
    transaction.subcategory = preset.name;

    // Apply GST
    if (preset.hasGST) {
      transaction.vat = this.transactionService.calculateVAT(transaction.amount);
    } else {
      transaction.vat = 0;
    }

    // Apply category
    transaction.atocategory = preset.atocategory;

    // Requires evidence
    transaction.internal = !preset.requiresEvidence;

    return this.transactionService.update(transaction);
  }

  canAutoSortTransactions() {
    if (this.activeCategory == 'expenses-business') {
      for (let preset of this.transactionPresets) {
        if (preset.name == this.activeExpenseCategory) {
          return true;
        }
      }
    }
    return false;
  }

  getAlphabetical(data: any) {
    return data.sort((a, b) => a.label.localeCompare(b.label));
  }

  showStats() {
    switch (this.activeCategory) {
      case "overview":
        return false;
      case "payroller-summary":
        return false;
      case "accounts":
        return false;
      default:
        return true;
    }
  }

  payPayroll() {
    this.bankService.openPayrollDialog();
  }
}

function setToMonday(date: Date): Date {
  var day = date.getDay() || 7;
  if (day !== 1)
    date.setHours(-24 * (day - 1));
  return date;
}
